/*
format
staticPath => for getstaticpath into [route]/[[...query]] to generate static page
noPath => not include into staticpath
animateHeader => header animate transparent to white
pattern => allow pass through else 404
ignore => ignore for checking to allow pass, if not match 404, not include for staticpath
*/
const routers = [
  {
    staticPath: [
      { params: { route: '' }, locale: 'en' },
      { params: { route: 'fr' }, locale: 'fr' },
      { params: { route: 'es' }, locale: 'es' },
    ],
    animateHeader: false,
    name: 'home',
    pattern: '/:lang',
    ignore: true,
  },
  {
    staticPath: [
      { params: { route: 'services', query: [] }, locale: 'en' },
      { params: { route: 'services', query: [] }, locale: 'fr' },
      { params: { route: 'servicios', query: [] }, locale: 'es' },
    ],
    animateHeader: false,
    componentPage: 'services',
    name: 'services',
    pattern: '/:route(\\?category=:category&subCategory=:subCategory(&partnerRef=:partnerRef))',
    newP: true,
  },
  {
    staticPath: [
      { params: { route: 'press-media', query: [] }, locale: 'en' },
      { params: { route: 'presse-media', query: [] }, locale: 'fr' },
      { params: { route: 'medios-prensa', query: [] }, locale: 'es' },
    ],
    animateHeader: false,
    componentPage: 'press-media',
    name: 'press-media',
    pattern: '/:route',
  },
  {
    staticPath: [
      { params: { route: 'sponsorship', query: [] }, locale: 'en' },
      { params: { route: 'parrainage', query: [] }, locale: 'fr' },
      { params: { route: 'patrocinio', query: [] }, locale: 'es' },
    ],
    animateHeader: false,
    componentPage: 'sponsorship',
    name: 'sponsorship',
    pattern: '/:route',
  },
  {
    staticPath: [
      { params: { route: 'contact', query: [] }, locale: 'en' },
      { params: { route: 'nous-contacter', query: [] }, locale: 'fr' },
      { params: { route: 'contactos', query: [] }, locale: 'es' },
    ],
    animateHeader: false,
    componentPage: 'contact',
    name: 'contact',
    pattern: '/:route',
  },
  {
    staticPath: [
      { params: { route: 'howto-ride', query: [] }, locale: 'en' },
      { params: { route: 'louer-un-espace', query: [] }, locale: 'fr' },
      { params: { route: 'alquilar-un-espacio', query: [] }, locale: 'es' },
    ],
    animateHeader: true,
    componentPage: 'howto-ride',
    name: 'howto-ride',
    pattern: '/:route',
  },
  {
    staticPath: [
      { params: { route: 'be-host', query: [] }, locale: 'en' },
      { params: { route: 'devenir-hote', query: [] }, locale: 'fr' },
      { params: { route: 'convertirse-en-anfitrion', query: [] }, locale: 'es' },
    ],
    animateHeader: true,
    componentPage: 'become-host',
    name: 'become-host',
    pattern: '/:route',
  },
  {
    staticPath: [
      { params: { route: 'insurance', query: [] }, locale: 'en' },
      { params: { route: 'assurance', query: [] }, locale: 'fr' },
      { params: { route: 'seguro', query: [] }, locale: 'es' },
    ],
    animateHeader: true,
    componentPage: 'insurance',
    name: 'insurance',
    pattern: '/:route',
  },
  {
    staticPath: [
      { params: { route: 'corporate-membership', query: [] }, locale: 'en' },
      { params: { route: 'accompagnement-workstars', query: [] }, locale: 'fr' },
      { params: { route: 'membresia-corporativa', query: [] }, locale: 'es' },
    ],
    animateHeader: false,
    componentPage: 'workstars',
    name: 'corporate-membership',
    pattern: '/:route',
  },
  {
    staticPath: [
      { params: { route: 'terms', query: [] }, locale: 'en' },
      { params: { route: 'conditions', query: [] }, locale: 'fr' },
      { params: { route: 'condiciones', query: [] }, locale: 'es' },
    ],
    animateHeader: false,
    componentPage: 'terms',
    name: 'terms',
    pattern: '/:route',
  },
  {
    staticPath: [
      { params: { route: 'privacy', query: [] }, locale: 'en' },
      { params: { route: 'confidentialite', query: [] }, locale: 'fr' },
      { params: { route: 'privacidad', query: [] }, locale: 'es' },
    ],
    animateHeader: false,
    componentPage: 'privacy',
    name: 'privacy',
    pattern: '/:route',
  },
  {
    staticPath: [
      { params: { route: 'legal', query: [] }, locale: 'en' },
      { params: { route: 'mentions-legales', query: [] }, locale: 'fr' },
      { params: { route: 'aviso-legal', query: [] }, locale: 'es' },
    ],
    animateHeader: false,
    componentPage: 'legal',
    name: 'legal',
    pattern: '/:route',
  },
  /* {
    staticPath: [
      { params: { route: 'rooms', query: [] }, locale: 'en' },
      { params: { route: 'salles', query: [] }, locale: 'fr' },
      { params: { route: 'salas', query: [] }, locale: 'es' },
    ],
    animateHeader: false,
    componentPage: 'space-public',
    name: 'spacepublic',
    pattern: '/:route/:slug',
  }, */
  /*
  MI-1242 set to false
  */
  ...([
  {
    staticPath: [
      { params: { route: 'space_add' }, locale: 'en' },
      { params: { route: 'space_add' }, locale: 'fr' },
      { params: { route: 'space_add' }, locale: 'es' },
    ],
    ignore: true,
    name: 'add_space_v3',
    pattern: '/dashboard-host/space-new/edit-100',
  },
  {
    staticPath: [
      { params: { route: 'dash_host_spaces' }, locale: 'en' },
      { params: { route: 'dash_host_spaces' }, locale: 'fr' },
      { params: { route: 'dash_host_spaces' }, locale: 'es' },
    ],
    ignore: true,
    name: 'dash_host_spaces',
    pattern: '/dashboard-host-spaces',
  },
  ]),
  ...([{
    staticPath: [
      { params: { route: 'user_account' }, locale: 'en', externalUrl: `${process.env.NEXT_PUBLIC_URL_V4}/user-account` },
      { params: { route: 'user_account' }, locale: 'fr', externalUrl: `${process.env.NEXT_PUBLIC_URL_V4}/fr/user-account` },
      { params: { route: 'user_account' }, locale: 'es', externalUrl: `${process.env.NEXT_PUBLIC_URL_V4}/es/user-account` },
    ],
    ignore: true,
    name: 'user_account_v3',
  }]),
  {
    staticPath: [
      { params: { route: 'dash_host_book' }, locale: 'en', externalUrl: `${process.env.NEXT_PUBLIC_URL_V4}/dashboard/host` },
      { params: { route: 'dash_host_book' }, locale: 'fr', externalUrl: `${process.env.NEXT_PUBLIC_URL_V4}/dashboard/host` },
      { params: { route: 'dash_host_book' }, locale: 'es', externalUrl: `${process.env.NEXT_PUBLIC_URL_V4}/dashboard/host` },
    ],
    ignore: true,
    name: 'dash_host_book',
  },
  {
    staticPath: [
      { params: { route: 'dash_rider_book', query: [] }, locale: 'en', externalUrl: `${process.env.NEXT_PUBLIC_URL_V4}/dashboard/rider` },
      { params: { route: 'dash_rider_book', query: [] }, locale: 'fr', externalUrl: `${process.env.NEXT_PUBLIC_URL_V4}/dashboard/rider` },
      { params: { route: 'dash_rider_book', query: [] }, locale: 'es', externalUrl: `${process.env.NEXT_PUBLIC_URL_V4}/dashboard/rider` },
    ],
    ignore: true,
    name: 'dash_rider_book',
  },
  {
    staticPath: [
      { params: { route: 'dash_invited_book', query: [] }, locale: 'en', externalUrl: `${process.env.NEXT_PUBLIC_URL_V4}/dashboard-guest/latest` },
      { params: { route: 'dash_invited_book', query: [] }, locale: 'fr', externalUrl: `${process.env.NEXT_PUBLIC_URL_V4}/dashboard-guest/latest` },
      { params: { route: 'dash_invited_book', query: [] }, locale: 'es', externalUrl: `${process.env.NEXT_PUBLIC_URL_V4}/dashboard-guest/latest` },
    ],
    ignore: true,
    name: 'dash_invited_book',
  },
  {
    staticPath: [
      { params: { route: 'selection', query: [] }, locale: 'en' },
      { params: { route: 'selection', query: [] }, locale: 'fr' },
      { params: { route: 'selection', query: [] }, locale: 'es' },
    ],
    name: 'bookmark',
    pattern: '/:route/:ref',
    ignore: true,
  },
  {
    staticPath: [
      { params: { route: 'corpo', query: [] }, locale: 'en' },
      { params: { route: 'corpo', query: [] }, locale: 'fr' },
      { params: { route: 'corpo', query: [] }, locale: 'es' },
    ],
    name: 'corpo',
    pattern: '/:route/:page',
    ignore: true,
  },

  {
    staticPath: [
      { params: { route: 'forgotpassword' }, locale: 'en', externalUrl: `${process.env.NEXT_PUBLIC_URL_V4}/forgot-password` },
      { params: { route: 'forgotpassword' }, locale: 'fr', externalUrl: `${process.env.NEXT_PUBLIC_URL_V4}/fr/mot-de-passe-oublie` },
      { params: { route: 'forgotpassword' }, locale: 'es', externalUrl: `${process.env.NEXT_PUBLIC_URL_V4}/es/contrasena-olvidada` },
    ],
    ignore: true,
    name: 'forgotpassword',
  },
  /*
  {
    staticPath: [
      { params: { route: 'createaccount' }, locale: 'en', externalUrl: `${process.env.NEXT_PUBLIC_URL_V3}/signup` },
      { params: { route: 'createaccount' }, locale: 'fr', externalUrl: `${process.env.NEXT_PUBLIC_URL_V3}/fr/inscription` },
      { params: { route: 'createaccount' }, locale: 'es', externalUrl: `${process.env.NEXT_PUBLIC_URL_V3}/es/registrar` },
    ],
    ignore: true,
    name: 'createaccount',
  }, */
  {
    staticPath: [
      { params: { route: 'brief', query: [] }, locale: 'en' },
      { params: { route: 'brief', query: [] }, locale: 'fr' },
      { params: { route: 'brief', query: [] }, locale: 'es' },
    ],
    animateHeader: false,
    componentPage: 'brief',
    name: 'brief',
    pattern: '/:route',
  },
  {
    staticPath: [
      { params: { route: 'hall-of-fame', query: [] }, locale: 'en' },
      { params: { route: 'hall-of-fame', query: [] }, locale: 'fr' },
      { params: { route: 'hall-of-fame', query: [] }, locale: 'es' },
    ],
    animateHeader: false,
    componentPage: 'hall-of-fame',
    name: 'hall-of-fame',
    pattern: '/:route',
  },
];

routers.push( // ======================= homepage cate===============
  {
    staticPath: [
      { params: { route: 'production', query: [] }, locale: 'en' },
      { params: { route: 'production', query: [] }, locale: 'fr' },
      { params: { route: 'produccion', query: [] }, locale: 'es' },
    ],
    animateHeader: true,
    componentPage: 'home',
    name: 'homeproduction',
    pattern: '/:category',
  },
  // ======================= homepage cate===============
  {
    staticPath: [
      { params: { route: 'member', query: [] }, locale: 'en' },
      { params: { route: 'membre', query: [] }, locale: 'fr' },
      { params: { route: 'miembro', query: [] }, locale: 'es' },
    ],
    name: 'userprofilpublic',
    pattern: '/:route/:userRef',
    ignore: true,
  },
);

export {
  routers,
};
